// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip.user-search-field-tooltip .tooltip-inner {\n\tmin-width: 400px;\n\tmax-width: 400px;\n\ttext-align: left;\n}\n.tooltip.user-search-field-tooltip .tooltip-inner p { margin-bottom: 5px;\n}\n.tooltip.user-search-field-tooltip .tooltip-inner p:last-child { margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
